/*
 * @description: 
 * @author: Jason Wong
 * @since: 2024-07-11 16:33:22
 */
import { TOKEN_KEY, ROLES_KEY, USER_INFO_KEY, DB_DICT_DATA_KEY, TENANT_ID, LOGIN_INFO_KEY, PROJ_CFG_KEY } from '../../enums/cacheEnum';
import { omit } from 'lodash';


const NOT_ALIVE = 0;

export class Memory {

  cache = {};
  alive;

  constructor(alive = NOT_ALIVE) {
    // Unit second
    this.alive = alive * 1000;
  }

  get getCache() {
    return this.cache;
  }

  setCache(cache) {
    this.cache = cache;
  }

  get(key) {
    return this.cache[key];
  }

  set(key, value, expires) {
    let item = this.get(key);

    if (!expires || expires <= 0) {
      expires = this.alive;
    }
    if (item) {
      if (item.timeoutId) {
        clearTimeout(item.timeoutId);
        item.timeoutId = undefined;
      }
      item.value = value;
    } else {
      item = { value, alive: expires };
      this.cache[key] = item;
    }

    if (!expires) {
      return value;
    }
    const now = new Date().getTime();
    item.time = now + this.alive;
    item.timeoutId = setTimeout(
      () => {
        this.remove(key);
      },
      expires > now ? expires - now : expires
    );

    return value;
  }

  remove(key) {
    const item = this.get(key);
    Reflect.deleteProperty(this.cache, key);
    if (item) {
      clearTimeout(item.timeoutId);
      return item.value;
    }
  }

  resetCache(cache) {
    Object.keys(cache).forEach((key) => {
      const k = key;
      const item = cache[k];
      if (item && item.time) {
        const now = new Date().getTime();
        const expire = item.time;
        if (expire > now) {
          this.set(k, item.value, expire);
        }
      }
    });
  }

  clear() {
    console.log('------clear------进入clear方法');
    Object.keys(this.cache).forEach((key) => {
      const item = this.cache[key];
      console.log('------clear------清除缓存', key, item);
      item.timeoutId && clearTimeout(item.timeoutId);
    });
    this.cache = {
      ...omit(this.cache, [TOKEN_KEY, USER_INFO_KEY, ROLES_KEY, DB_DICT_DATA_KEY, TENANT_ID, LOGIN_INFO_KEY, PROJ_CFG_KEY]),
    };
    console.log('------clear------清除缓存后', this.cache);
  }
}
